DialogController = App.loadClass 'core::Angular/DialogController'

class exports.NewCompanyController extends DialogController
    constructor: (@scope, @transitions, @modalInstance, @service) ->
        super @scope, @transitions, @modalInstance

        @scope.title = 'New Company'
        @scope.username = ''
        @scope.company = ''
        @scope.password = ''
        @scope.phone = ''
        @scope.email = ''
        @scope.address1 = ''
        @scope.address2 = ''
        @scope.city = ''
        @scope.state = ''
        @scope.zipcode = ''

    save: () =>
        @service.createNewCompany(
            @scope.username
            @scope.company
            @scope.password
            @scope.phone
            @scope.email
            @scope.address1
            @scope.address2
            @scope.city
            @scope.state
            @scope.zipcode
        ).then (response) =>
            @closeWithAlert(response.data.status)

